import React, { useState, useEffect } from 'react';
import Post from '../../../../utils/Post';
import ContenedorPerfil from './ContenedorPerfil';
import { id } from 'date-fns/locale';

const AdministradorDePerfiles = (p) => {
    const show_dialog = p.show_dialog;
    const [data, setdata] = useState({ relaciones: {}, relaciones_lista: [], perfiles: [], menus: [], submenus: [] });
    const [select, setselect] = useState({ perfil: -1, menu: -1 });
    const [loader, setloader] = useState(false);
    const [nuevo, setnuevo] = useState({ submenu: '', menu: '', perfil: '' });
    var counter = 0;
    useEffect(() => { getData(); }, [p.change]);

    const getAPI = async (uri, data) => {
        let resp = await Post(uri, data, 'POST', setloader);
        if (resp.estatus) return resp;
        show_dialog("Error", resp.msj ? resp.msj : "Error de conexión");
        return false;
    }

    const getData = async () => {
        let resp = await getAPI("secure/users/get", {});
        if (resp) setdata(resp.data);
    }

    const listadoSubmenus = () => {
        let submenus = [];
        let nombres = [];
        let subs = data.submenus;
        let len = subs.length;
        for (let i = 0; i < len; i++) {
            let nombre = subs[i].nombre.toUpperCase();
            if (nombres.includes(nombre)) continue;
            nombres.push(nombre);
            submenus.push({ nombre: nombre, id: subs[i].id });
        }
        return submenus;
    }

    const listaMenus = () => {
        let menus = [];
        let nombres = [];
        let subs = data.menus;
        let len = subs.length;
        for (let i = 0; i < len; i++) {
            let nombre = subs[i].nombre.toUpperCase();
            if (nombres.includes(nombre)) continue;
            nombres.push(nombre);
            menus.push({ nombre: nombre, id: subs[i].id });
        }
        return menus;
    }

    const abrir = (name, index) => {
        if (name === 'perfil') {
            if (index !== select.perfil) setselect({ perfil: index, menu: -1 });
            autoScroll(`perfil${index}`);
        } else if (name === 'menu') {
            if (index !== select.menu) setselect({ ...select, menu: index });
        }
    }

    const autoScroll = (id) => {
        setTimeout(() => {
            let elemento = document.getElementById(id);
            if (elemento) elemento.scrollIntoView({ behavior: "smooth" });
        }, 200);
    }

    const keyGen = () => { counter++; return (counter + " " + counter); }

    const changeVal = (e) => {
        let { name, value } = e.target;
        setnuevo({ ...nuevo, [name]: value });
    }

    const agregar = async () => {
        let resp = await Post('secure/relaciones/add', { perfil: nuevo.perfil, menu: nuevo.menu, submenu: nuevo.submenu, }, 'POST', setloader);
        if (resp.estatus) {
            getData();
            setnuevo({ submenu: '', menu: '', perfil: '' });
        }
    }

    const perfilesExistentes = () => {
        let perfiles = [];
        let len = data.relaciones_lista.length;
        for (let i = 0; i < len; i++) {
            if (perfiles.includes(data.relaciones_lista[i].perfil_nombre)) continue;
            perfiles.push(data.relaciones_lista[i].perfil_nombre);
        }
        return perfiles;
    }
    const perfilesFaltantes = () => {
        let perfiles = data.perfiles;
        let existentes = perfilesExistentes();
        let noAgregados = [];
        let len = perfiles.length;
        for (let i = 0; i < len; i++) {
            if (existentes.includes(perfiles[i].nombre)) continue;
            noAgregados.push(perfiles[i]);
        }
        return noAgregados;
    }


    return (
        <div className='bw-1200 p-2 bg-white2 blur-s shadow-multi m-0 round-m relative dosis'>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='w-100 mb-1 mt-0 text-center text-xl text-bold'>
                    <div className='w-100 m-0 p-0 text-center'>Administrador de menús y secciones</div>
                    <div className='w-100 m-0 p-0 text-center text-s text-300'>
                        Administre que menus y a que secciónes tendrán acceso los perfiles de usuario
                    </div>
                </div>
                {data.relaciones_lista.map((relacion, index) =>
                    <React.Fragment key={keyGen()}>
                        <ContenedorPerfil
                            select={select}
                            relacion={relacion}
                            index={index}
                            abrir={abrir}
                            setloader={setloader}
                            submenus={listadoSubmenus()}
                            menus={listaMenus()}
                            keyGen={keyGen}
                            refresh={() => getData()}
                            cerrar={() => { setselect({ perfil: -1, menu: -1 }); autoScroll(`perfil${index}`); }}
                        />
                    </React.Fragment>
                )}
                <div className='w-100 mt-2'></div>
                <div className='w-100 mt-4 mb-2 text-l text-bold text-center'>
                    Agregue nuevo perfil de usuario
                    <div className='text-s text-300 text-center'>Seleccione el perfil, un menú y una sección para hacerla disponible, si no hay perfiles disponibles es que todos tienen menús asignados</div>
                </div>

                <div className='form-group bw-250 mb-2'>
                    <select className='form-control form-control-sm shadow border round-xxl text-center text-bold'
                        name='perfil'
                        value={nuevo.perfil}
                        onChange={changeVal}>
                        <option value='' >Seleccione un perfil</option>
                        {perfilesFaltantes().map((perfil, i) =>
                            <option key={keyGen()} value={perfil.id}>{perfil.nombre}</option>
                        )}
                    </select>
                </div>

                <div className='form-group bw-250 mb-2'>
                    <select className='form-control form-control-sm shadow border round-xxl text-center text-bold'
                        name='menu'
                        value={nuevo.menu}
                        onChange={changeVal}>
                        <option value='' >Seleccione un menú</option>
                        {listaMenus().map((menu, i) =>
                            <option key={keyGen()} value={menu.id}>{menu.nombre}</option>
                        )}
                    </select>
                </div>

                <div className='form-group bw-250 mb-2'>
                    <select className='form-control form-control-sm shadow border round-xxl text-center text-bold'
                        name='submenu'
                        value={nuevo.submenu}
                        onChange={changeVal}>
                        <option value='' >Seleccione una sección</option>
                        {listadoSubmenus().map((submenu, i) =>
                            <option key={keyGen()} value={submenu.id}>{submenu.nombre}</option>
                        )}
                    </select>
                </div>
                <div className='form-group bw-150 mb-2 contenedor'>
                    <button className='w-100 btn btn-sm text-bold btn-warning shadow border border-2 border-dark round-xxl'
                        type='button'
                        onClick={agregar}
                        disabled={nuevo.menu == "" || nuevo.submenu == "" || nuevo.perfil == ''}>Agregar</button>
                </div>
            </div>
            {loader && <div className='blur-s w-100 h-100 round-m bg-white4' style={{ position: 'fixed', left: 0, top: 0 }}><div className='loader-local'></div></div>}
        </div>
    )
}

export default AdministradorDePerfiles;